import { createContext } from 'react'

import { RootContent } from '../graphql/global.graphql'

const GlobalContentContext = createContext<RootContent | null>(null)

export default GlobalContentContext
